<label #label>
  <ng-content select="label"></ng-content>
</label>
<span #icon>
  <ng-content select="mat-icon"></ng-content>
</span>
<span #img>
  <ng-content select="img"></ng-content>
</span>
